import { Box, BoxProps, ColorOptions, IconNew as Icon, Spacer, TextNew as Text } from '@jfs/ui-new'

export const DefaultInnerComp = ({
  innerCompTitle = 'Drop your Bulk Refund File here (CSV file supported)',
  innnerCompSubtitle = 'Browse your file',
  filename,
}: any) => {
  return (
    <>
      <Box {...styles.container}>
        {!filename && (
          <>
            <Box {...styles.addContainer}>
              <Icon id={'ADD'} color={'WHITE'} size={24} />
            </Box>
            <Spacer size={24} direction={'vertical'} />
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
              {innerCompTitle}
            </Text>
            <Spacer size={8} direction={'vertical'} />
            {innnerCompSubtitle && (
              <Text fontFamily={'jiotype-medium'} fontSize={12} color={'PRIMARY_GREY'}>
                {'or'}
              </Text>
            )}
            <Spacer size={8} direction={'vertical'} />
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
              {innnerCompSubtitle}
            </Text>
          </>
        )}
        {!!filename && (
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
            {filename}
          </Text>
        )}
      </Box>
      <Spacer size={16} direction={'vertical'} />
    </>
  )
}

const styles = {
  container: {
    borderStyle: 'dashed',
    height: '35vh',
    minHeight: 200,
    width: '40vw',
    minWidth: 400,
    paddingHorizontal: 'MEDIUM',
    borderWidth: 1,
    borderRadius: '4px',
    borderColor: '#0186B080' as ColorOptions,
    underlayColor: 'WHITE',
    align: 'center',
    justify: 'center',
    bg: '#0186B00A' as ColorOptions,
  } as BoxProps,
  addContainer: {
    width: '72px',
    height: '72px',
    borderRadius: '36px',
    bg: 'BLUE',
    align: 'center',
    justify: 'center',
  } as BoxProps,
}
